import { StrictMode } from "react";
// import { FaroErrorBoundary } from "@grafana/faro-react";
import { AlertCircle, CheckCircle, Info, XCircle } from "lucide-react";
import { createRoot } from "react-dom/client";
import { Toaster } from "@/components/ui/sonner.tsx";
import { TooltipProvider } from "@/components/ui/tooltip.tsx";
import AuthProvider from "@/app/_providers/auth-provider.tsx";
import NuqsProvider from "@/app/_providers/nuqs-provider.tsx";
import TanstackQueryProvider from "@/app/_providers/tanstack-query-provider.tsx";
import TanstackRouterProvider from "@/app/_providers/tanstack-router-provider.tsx";
import { ThemeProvider } from "@/app/_providers/theme-provider";
import "./app/index.css";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    {/* <FaroErrorBoundary> */}
      <TanstackQueryProvider>
        <NuqsProvider>
          <AuthProvider>
            <ThemeProvider defaultTheme="light" storageKey="vite-ui-theme">
              <TooltipProvider>
                <TanstackRouterProvider />
                <Toaster
                  closeButton
                  icons={{
                    success: <CheckCircle className="size-5 text-green-500" />,
                    info: <Info className="size-5 text-blue-500" />,
                    warning: <AlertCircle className="size-5 text-yellow-500" />,
                    error: <XCircle className="size-5 text-red-500" />,
                  }}
                />
              </TooltipProvider>
            </ThemeProvider>
          </AuthProvider>
        </NuqsProvider>
      </TanstackQueryProvider>
    {/* </FaroErrorBoundary> */}
  </StrictMode>
);
